import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import * as servicioService from "../../services/servicioService";
import { Grid, Card, CardContent, Snackbar, Alert } from '@mui/material';
import InvoiceItem from '../../components/InvoiceItem'
import MantenimientoForm from '../../components/common/MantenimientoForm';
import { useMantenimiento } from '../../hooks/useMantenimiento';
import { activeValidations as activeValidationsFee } from "../../redux/invoiceItemSlice";

const Edit = (props) => {
    const invoiceItem = useSelector((state) => state.invoiceItem.entity);
    const invoiceItemValidation = useSelector((state) => state.invoiceItem.validationMessage);

    const [openMessage, setOpenMessage] = useState(false)
    const onCloseMessage = () => { setOpenMessage(!openMessage); }
    const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });
    const dispatch = useDispatch();
    const params = useParams();
    const { isReadOnly, setIsReadOnly } = useMantenimiento("conceptoCobro");
    const postEntity = async () => {
      var dataPost = {
        ...invoiceItem
      }

      var ValidationMessages = invoiceItemValidation;

      if (ValidationMessages.length > 0) {
        setPropsMessage({ severity: "error", message: ValidationMessages.join(" - ") })
        dispatch(activeValidationsFee());
        setOpenMessage(true);
      }
      else {
        await servicioService.addUpdateConceptoCobro(dataPost)
          .then(response => {
            setPropsMessage({ severity: "success", message: "Se guardaron los datos con exito" })
            setOpenMessage(true);
            setIsReadOnly(true);
          })
          .catch(error => {
            setPropsMessage({ severity: "error", message: "Hubo un error" })
            setOpenMessage(true);
          });
      }
  }

  return (
    <div>
      <MantenimientoForm
        title={(params.id == 0 ? "Nueva" : "Editar") + " Concepto Cobro"}
        backTo={"/invoiceItem"}
        onSave={postEntity}
        disabled={isReadOnly}
      >
        <Grid container spacing={1} sx={{
          "& .MuiGrid-root>.MuiGrid-item": {
            paddingTop: "8px"
          },
        }}>
          <Grid item xs={12} sm={12}>
            <Card >
              <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                <InvoiceItem isReadOnly={isReadOnly} />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </MantenimientoForm>
      <Snackbar open={openMessage} autoHideDuration={5000} onClose={onCloseMessage}
        anchorOrigin={{vertical: "top", horizontal: "center"}}>
        <Alert onClose={onCloseMessage} severity={propsMessage.severity}>
          {propsMessage.message}
        </Alert>
      </Snackbar>
    </div>
  )
}

export default Edit